import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <div className="relative min-h-screen bg-cream overflow-hidden flex items-center" data-id="element-74">
      {/* Subtle background image */}
      <div className="absolute inset-0 z-0 opacity-10" data-id="element-75">
        <img src="https://cdn.magicpatterns.com/uploads/bDwwK8cbiXmwZcLDtiPZ14/heylloyd-image-1769528908382.png" alt="Cocina acogedora" className="w-full h-full object-cover" data-id="element-76" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-20" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-78">
          {/* Badge */}
          <motion.span initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="inline-block px-5 py-2 rounded-full bg-terracotta/10 text-terracotta font-bold text-sm mb-8 tracking-widest uppercase border border-terracotta/20" data-id="element-79">
            Para mujeres 35+
          </motion.span>

          {/* Main Headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-warm-dark mb-8 leading-tight" data-id="element-80">
            No te falta disciplina.
            <br data-id="element-81" />
            <span className="text-terracotta" data-id="element-82">Te falta un sistema.</span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.5
        }} className="text-xl md:text-2xl text-warm-gray mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-83">
            14 días para apagar antojos y recuperar el control de tus tardes
            (sin contar calorías ni vivir a dieta).
          </motion.p>

          {/* CTA Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.7
        }} className="flex flex-col items-center gap-4 mb-12" data-id="element-84">
            <Button size="lg" withIcon onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-85">
              Quiero el Sistema
            </Button>
            <p className="text-sm text-warm-gray italic" data-id="element-86">
              *Descarga digital inmediata
            </p>
          </motion.div>

          {/* Trust indicators */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.7,
          delay: 0.9
        }} className="flex flex-wrap justify-center gap-8 text-sm text-warm-gray pt-8 border-t border-warm-gray/20 max-w-2xl mx-auto" data-id="element-87">
            <div className="flex items-center gap-2" data-id="element-88">
              <span className="text-terracotta text-lg" data-id="element-89">✓</span>
              <span data-id="element-90">Sin contar calorías</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-91">
              <span className="text-terracotta text-lg" data-id="element-92">✓</span>
              <span data-id="element-93">Sin báscula</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-94">
              <span className="text-terracotta text-lg" data-id="element-95">✓</span>
              <span data-id="element-96">Sin apps complicadas</span>
            </div>
          </motion.div>
        </motion.div>

        {/* Featured Image Below */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.1
      }} className="mt-16 relative max-w-4xl mx-auto" data-id="element-97">
          {/* Decorative background */}
          <div className="absolute -inset-6 bg-gradient-to-br from-terracotta/10 via-peach/10 to-transparent rounded-3xl blur-3xl" data-id="element-98" />

          {/* Main image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/bDwwK8cbiXmwZcLDtiPZ14/heylloyd-image-1769528908382.png" alt="Sistema Anti-Antojos en tablet sobre mesa de cocina con frutas frescas" className="w-full h-auto" data-id="element-100" />
          </div>

          {/* Floating badge */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 1.5,
          type: 'spring'
        }} className="absolute -bottom-4 left-1/2 -translate-x-1/2 bg-white rounded-xl shadow-xl p-3 sm:p-4 border-2 border-terracotta/20 max-w-[280px] sm:max-w-none" data-id="element-101">
            <div className="flex items-center gap-2 sm:gap-4" data-id="element-102">
              <div className="bg-terracotta/10 rounded-full p-2" data-id="element-103">
                <span className="text-xl sm:text-2xl" data-id="element-104">⚓</span>
              </div>
              <div className="text-left" data-id="element-105">
                <div className="font-bold text-warm-dark text-sm sm:text-base" data-id="element-106">
                  Método 3 Anclas
                </div>
                <div className="text-xs sm:text-sm text-warm-gray" data-id="element-107">
                  Sistema de 14 días
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>

      {/* Subtle wave divider */}
      <div className="absolute bottom-0 left-0 right-0 z-0" data-id="element-108">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" data-id="element-109">
          <path d="M0 0L60 10C120 20 240 40 360 46.7C480 53 600 47 720 43.3C840 40 960 40 1080 46.7C1200 53 1320 67 1380 73.3L1440 80V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0V0Z" fill="white" fillOpacity="0.5" data-id="element-110" />
        </svg>
      </div>
    </div>;
}